import React from "react"

const MicromarkingWrapper = (props) => <div {...props} />

export default MicromarkingWrapper
